import { Button } from "@admin/components/atoms/Button";
// import { Accordion } from "@admin/components/molecules/Accordion";
import { DataTable, DataTableColumn } from "@admin/components/molecules/Table";
import useLogBookModals from "@admin/hooks/useLogBookModals";
import { CompanyLocation, LogBookControl } from "@enos-monorepo/lib";
import { useTranslation } from "react-i18next";

import { FailReportModal } from "./Modals/FailReportModal";
import { FoodPoisoningModal } from "./Modals/FoodPoisoningModal";
import { ProductReturnModal } from "./Modals/ProductReturnModal";

interface LogBookProps {
  selectedLocation?: CompanyLocation;
  companyId?: string;
}

export type LogBookType = { title: string; type: LogBookControl };

export function LogBook({ selectedLocation, companyId }: LogBookProps) {
  const { t } = useTranslation();
  const { openModal, closeModals, modalOpen } = useLogBookModals();

  const logBookData: LogBookType[] = [
    // {
    //   title: t(`food.${LogBookControl.SafeHeating}`),
    //   type: LogBookControl.SafeHeating,
    // },
    {
      title: t(`food.${LogBookControl.FailReport}`),
      type: LogBookControl.FailReport,
    },
    {
      title: t(`food.${LogBookControl.FoodPoisoning}`),
      type: LogBookControl.FoodPoisoning,
    },
    {
      title: t(`food.${LogBookControl.ProductReturn}`),
      type: LogBookControl.ProductReturn,
    },
  ];

  const columns: DataTableColumn<LogBookType>[] = [
    {
      id: "Title",
      accessorKey: "title",
    },
    {
      id: "Actions",
      accessorKey: "actions",
      size: 120,
      cell: (row) => {
        const control = row.row.original.type;
        return (
          <Button size="sm" onClick={() => openModal(control)}>
            <i className="ki-outline ki-plus-squared"></i> {t("food.Entry")}
          </Button>
        );
      },
    },
  ];

  return (
    <div className="flex flex-col gap-7.5">
      <DataTable
        columns={columns}
        data={logBookData}
        title={t("food.Log Book Controls")}
        showHeadRow={false}
      />

      {/* <Accordion /> */}

      <FailReportModal
        title={t(`food.${LogBookControl.FailReport}`)}
        open={modalOpen[LogBookControl.FailReport]}
        onClose={closeModals}
        companyId={companyId}
        companyLocationId={selectedLocation?.id}
      />
      <ProductReturnModal
        title={t(`food.${LogBookControl.ProductReturn}`)}
        open={modalOpen[LogBookControl.ProductReturn]}
        onClose={closeModals}
        companyId={companyId}
        companyLocationId={selectedLocation?.id}
      />
      <FoodPoisoningModal
        title={t(`food.${LogBookControl.FoodPoisoning}`)}
        open={modalOpen[LogBookControl.FoodPoisoning]}
        onClose={closeModals}
        companyId={companyId}
        companyLocationId={selectedLocation?.id}
      />
    </div>
  );
}
